import { Validator } from '@vista-digital/validator';
export const carouselNumberOrAutoValidator = Validator.any([
    Validator.number(),
    Validator.isEqualTo('auto')
]);
const carouselSettingsValidatorBase = {
    slidesToShow: carouselNumberOrAutoValidator,
    slidesToScroll: carouselNumberOrAutoValidator,
    itemWidth: Validator.optional(Validator.number()),
    duration: Validator.optional(Validator.number()),
    exactWidth: Validator.optional(Validator.boolean()),
    scrollLock: Validator.optional(Validator.boolean()),
    resizeLock: Validator.optional(Validator.boolean()),
    draggable: Validator.optional(Validator.boolean()),
    rewind: Validator.optional(Validator.boolean())
};
export const carouselBreakpointValidator = Validator.object({
    breakpoint: Validator.number(),
    settings: Validator.object(carouselSettingsValidatorBase)
});
export const carouselSettingsValidator = Validator.object(Object.assign(Object.assign({}, carouselSettingsValidatorBase), { responsive: Validator.optional(Validator.array({ items: carouselBreakpointValidator })) }));
